<template>
  <section class="catalog">
<!--
<alarm-modal ref="changeTypeModal" @ok="okChangeTypeModal" @cancel="cancelChangeTypeModal">
      При переходе между группами <span>Тарифные</span> и <span>Общие</span> все фильтры и результаты поиска будут сброшены
    </alarm-modal>
    -->
    <alarm-modal
      ref="limitSelected"
      modal-class="modal-filter-large"
      @ok="okLimitSelectedModal"
      @cancel="cancelLimitSelectedModal"
      ok-text="Вернуться"
      cancel-text="Очистить выделенные">
      Вы достигли лимита в {{ maxSelected }} выделенных референсов. Чтобы продолжить, необходимо завершить работу  текущим списком (экспортировать выбранные), очистить выделенные референсы и начать работу над новым списком.
    </alarm-modal>

    <div class="container">
      <h1 class="catalog__title">Каталог товаров</h1>
      <div class="row">
        <!--  алерт -->
        <div class="col-lg-9 col-md-9 col-xs-12">
          <alert storage-key="api-alert">
            Раздел является веб-версией базы данных <a class="linkGreenConditions uLine" :href="`${siteUrl}/documentation-api/default/intro`">API</a> по продукции Systeme Electric.<br>
            Сайт не является интернет-магазином. Уточнить наличие и стоимость можно через наших <a class="linkGreenConditions uLine" href="https://www.se.com/ru/ru/locator/?locale=RU_ru2&type=search&locator=distributor&header=se&mxdi=100&advs=1">Партнеров</a>.
          </alert>
        </div>
      </div>
      <!-- заметка к алерту -->
      <div class="row">
        <div class="col-lg-7">
          <p class="comment-text">
            Для поиска нескольких референсов используйте разделитель «;» без пробелов и кавычек.<br>
            Максимальный лимит запроса – 250 референсов. Для увеличения лимита поиска используйте <a class="linkGreenConditions" :href="`${siteUrl}/documentation-api`">REST API</a>.
          </p>
        </div>
      </div>

      <search-bar />

      <!-- строка со всем контентом -->
      <div class="row all-content">
        <div class="col-lg-3 col-md-12 col-sm-12 tabbs">
          <div class="row filter__header">
            <div class="filter__header-text">
              <span>ФИЛЬТРЫ</span>
              <button
                v-if="filtersLength"
                class="btn linkBlueConditions"
                @click.once="clearFilters">
                Очистить все <span>({{ filtersLength }})</span>
              </button>
            </div>
          </div>

          <!-- строка с табами (Временно скрыты, по умолчанию отображаются тарифные) -->
          <div class="row catalog__tabs">
            <div class="col-sm-12">
<!--              <ul class="nav nav-tabs">
                <li :class="{'active': getType === 'common'}" @click="setType('common')">
                  <a href="javascript:void(0);" class="titleTab">
                    Общее
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" v-tippy="{ arrow : true }" title="Структура вложенности референсов с сайта se.com" >
                      <circle cx="10" cy="10" r="9" stroke="#098844" stroke-width="2"></circle>
                      <rect x="9" y="9" width="2" height="6" fill="#098844"></rect>
                      <rect x="9" y="5" width="2" height="2" fill="#098844"></rect>
                    </svg>
                  </a>
                </li>
                <li :class="{'active': getType === 'rate'}">
                  <a href="javascript:void(0);" class="titleTab" @click="setType('rate')">
                    Тарифное
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" v-tippy="{ arrow : true }" title="Структура вложенности  референсов из тарифа">
                      <circle cx="10" cy="10" r="9" stroke="#098844" stroke-width="2"></circle>
                      <rect x="9" y="9" width="2" height="6" fill="#098844"></rect>
                      <rect x="9" y="5" width="2" height="2" fill="#098844"></rect>
                    </svg>
                  </a>
                </li>                  
              </ul>-->

              <!-- Tab panes -->
              <div class="tab-content">
                <div ref="foundPopup" v-show="getFoundDom && foundPopup" class="modal-founded-wrap">
                  <div class="modal-founded">
                    <p class="modal-founded-text">Найдено <span>{{ getFoundCount }}</span></p>
                    <button class="btn modal-founded-btn" @click="search">Показать</button>
                  </div>
                </div>

<!--                <filter-type-common v-if="getType === 'common'" />-->
                <filter-type-rate v-if="getType === 'rate'" />
                <filter-type-static />

                <button class="btn greenBtnCondition btnPopapShowResults" @click="search" :disabled="!getFoundDom || !foundPopup">
                  Показать результаты <span v-if="getFoundDom && foundPopup">({{ getFoundCount }})</span>
                </button>
              </div>
            </div>
          </div>
        </div>

        <div class="col-lg-9 col-md-12 col-sm-12 all-content-inner">
          <filter-badges :type="getType" />

          <product-table />

        </div>
      </div>
    </div>
    <archive-modal />
    <archive-success-modal />
  </section>
</template>

<script>
import Alert from '@/components/Alert'
import FilterTypeRate from '@/components/FilterTypeRate'
import FilterTypeStatic from '@/components/FilterTypeStatic'
import AlarmModal from '@/components/AlarmModal'
import FilterBadges from '@/components/FilterBadges'
import ProductTable from '@/components/ProductTable'
import SearchBar from '@/components/SearchBar'
import ArchiveModal from '@/components/ArchiveModal'
import ArchiveSuccessModal from '@/components/ArchiveSuccessModal'
import { mapGetters } from 'vuex'
import {
  CLEAR_FILTER,
  SET_TYPE,
  SEARCH
} from '@/store/actions/search'
import { SET_SELECTED } from '@/store/actions/product'
import { MAX_SELECTED } from '@/store/modules/product'
import { SET_FOUND_DOM } from '@/store/actions/found'
import { createPopper } from '@popperjs/core'
import { EVENT_FILTER_SHOWN_TOGGLE } from '@/components/FilterBlock'

export default {
  name: 'home',
  components: {
    Alert,
    FilterTypeRate,
    AlarmModal,
    FilterBadges,
    SearchBar,
    ArchiveModal,
    ArchiveSuccessModal,
    ProductTable,
    FilterTypeStatic
  },
  data: () => ({
    foundPopup: null
  }),
  computed: {
    filtersLength () {
      return this.getFiltersLength(this.getType) + this.getFiltersLength('static')
    },
    maxSelected () {
      return MAX_SELECTED
    },
    siteUrl () {
      return process.env.VUE_APP_API_URL
    },
    ...mapGetters([
      'getFiltersLength',
      'getQuery',
      'getFile',
      'getType',
      'getSelected',
      'getFoundDom',
      'getFoundCount',
      'getTableFilter',
      'isEmptyTableFilters',
      'getProductPageLines',
      'hasAnyFilter'
    ])
  },
  watch: {
    'getSelected.length': {
      handler: function (value, oldValue) {
        if (value >= MAX_SELECTED && oldValue < MAX_SELECTED) {
          this.$refs.limitSelected.show()
        }
      }
    },
    getFoundDom: {
      handler: function (value) {
        this.destroyPopup()
        if (value) {
          this.createPopup(value)
        }
      }
    }
  },
  created () {
    this.$root.$on(EVENT_FILTER_SHOWN_TOGGLE, this.updatePopup)
  },
  mounted () {
    const { type } = this.$route.query
    this.$store.dispatch(SET_TYPE, type ? type : 'rate')
  },
  methods: {
    search () {
      const { $router: router } = this
      this.$store.dispatch(SEARCH, { router })
    },
    createPopup (dom) {
      this.foundPopup = createPopper(dom, this.$refs.foundPopup, {
        placement: 'right'
      })
    },
    destroyPopup () {
      if (this.foundPopup) {
        this.foundPopup.destroy()
        this.foundPopup = null
      }
    },
    updatePopup () {
      if (this.foundPopup) {
        this.foundPopup.update()
      }
    },
    setType (value) {
      if (value !== this.getType) {
        if (this.hasAnyFilter) {
          this.$refs.changeTypeModal.show(value)
        } else {
          this.clearFilters()
          this.$store.dispatch(SET_TYPE, value)
        }
      }
    },
    okChangeTypeModal (context) {
      this.$refs.changeTypeModal.hide()
      this.clearFilters()
      this.$store.dispatch(SET_TYPE, context)
    },
    cancelChangeTypeModal () {
      this.$refs.changeTypeModal.hide()
    },
    okLimitSelectedModal () {
      this.$refs.limitSelected.hide()
    },
    cancelLimitSelectedModal () {
      this.$store.dispatch(SET_SELECTED, [])
      this.$refs.limitSelected.hide()
    },
    clearFilters () {
      this.$store.dispatch(SET_FOUND_DOM, null).then(() => {
        const { $router: router } = this
        this.$store.dispatch(CLEAR_FILTER, { router })
      })
    }
  },
  beforeDestroy () {
    this.$root.$off(EVENT_FILTER_SHOWN_TOGGLE, this.updatePopup)
  }
}
</script>